var app = angular.module('leonardo');

var PmsPlatformsService = function (BaseRestService, RestangularProvider) {
  var service = new BaseRestService('pms-platforms');

  service.rumPmsSync = function(params) {
    return RestangularProvider.all('run-pms-sync').customPOST(params, '');
  };

  return service;
};

app.factory('PmsPlatformsService', ['BaseRestService', 'Restangular', PmsPlatformsService]);
